<template>
  <v-form
    v-if="id && shift"
    v-model="valid"
    class="py-8 bg-light-blue-main">
    <div class="pa-4">
      <v-container class="bordered bg-white">
        <NormalInput
          :id="id"
          class="mb-4"
          field="name" />
        <NormalInput
          :id="id"
          class="mb-4"
          field="description" />
      </v-container>

      <nonWageLaborCostTablePart
        class="bordered bg-white"
        :shift-id="id" />

      <v-container class="bordered bg-white mt-4">
        <div style="width: 50%">
          <CalcOutput
            :id="id"
            outside-label
            unit="%"
            field="mandatory_charges_percentage_shift" />

          <CalcOutput
            :id="id"
            outside-label
            unit="%"
            field="voluntary_charges_percentage_shift" />
          <CalcOutput
            :id="id"
            outside-label
            unit="%"
            field="non_wage_labour_cost_surcharge_percentage_shift" />
        </div>
      </v-container>
    </div>
  </v-form>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import nonWageLaborCostTablePart from "./NonWageLaborCostTable.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import NormalInput from "@/components/Elements/NormalInput.vue";
import CalcOutput from "@/components/Elements/CalcOutput.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();

const valid = ref(false);

// Form fields, only for validation
const shift = ref(null);
const { required } = useCommonRules(t);

const props = defineProps({
  closeDialog: {
    type: Function,
    required: true
  },
  id: {
    type: String,
    required: true
  }
});

const route = useRoute();

const id = computed(() => route.params.nodeId);

onMounted(() => {
  shift.value = spaceStore.getElement(id.value);
});
</script>

<style>
.v-form {
  max-height: 100%;
  overflow: auto;
  background-color: white;
}
</style>
